export default "__VITE_ASSET__dCb1VIyi__"